import React from "react";
import "../../css/CRUDModal.css";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";
import CrossIcon from "../../assets/Icons/cross_svg.svg";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";

const WalletBalanceModal = ({
  show,
  handleClose,
  walletDetail,
  walletTitle,
}) => {
  const handleBack = () => {
    handleClose();
  };

  return (
    <>
      {show && (
        <div className="fixed top-[250px] left-1/2 transform -translate-x-1/2 z-50 shadow-2xl rounded-3xl">
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "597px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
               <img
                  src={LeftCircle}
                  alt="leftImg"
                  className="absolute left-0 bottom-0 w-[110px] h-[105px]"
                />
                <img
                  src={RightCircle}
                  alt="leftImg"
                  className="absolute right-0 top-0 w-[110px] h-[105px]"
                />
              <div
                className="modal-header flex items-center justify-between border-b-0 pb-[1rem]"
                style={{
                  // padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                }}
              >
                <div className="flex items-center gap-2">
                <AccountBalanceWalletIcon fontSize="small" sx={{ color: "#FF702B" }} className="cursor-pointer" />

                <h5 className="modal-title main-title font-medium text-lg">{`${walletTitle} Details`}</h5>
                </div>
                <img
                    src={CrossIcon}
                    alt="filter icon"
                    className="w-[30px] h-[30px] cursor-pointer z-20"
                    onClick={handleBack}
                  />
              </div>
              <form>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "24px",
                  }}
                >
                  {walletDetail && walletDetail.length > 0 ? (
                    <div className="table-container" style={{ width: "100%" }}>
                      <div className="table-wrapper">
                        <table className="custom-table">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>
                                {walletTitle === "Main Balance Amount"
                                  ? "Amount"
                                  : "Count"}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {walletDetail?.map((item, index) => {
                              const [label, value] = Object.entries(item)[0];
                              const isLastItem =
                                index === walletDetail.length - 1;
                              return (
                                <tr
                                  key={item.id}
                                  style={{
                                    borderBottom: !isLastItem
                                      ? "1px solid #dee2e6"
                                      : "none",
                                  }}
                                >
                                  <td>{label}</td>
                                  <td>
                                    {walletTitle === "Main Balance Amount" && "₹ "}
                                    {value ?? 0}{" "}
                                    {walletTitle !== "Main Balance Amount" && "Qty"}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "#888",
                        fontStyle: "italic",
                      }}
                    >
                      No wallet details available.
                    </div>
                  )}
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-back"
                    onClick={handleBack}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WalletBalanceModal;
